import { RefObject } from 'react'
import { View } from 'react-native'

interface ContentDimensions {
    height: number
    width: number
}

export const measureContentDimensions = async (
    contentRef: RefObject<View | null>
): Promise<ContentDimensions> => {
    return new Promise((resolve, reject) => {
        if (!contentRef.current) return reject(new Error('contentRef.current is not available'))

        contentRef.current.measure((_, _1, width, height) => resolve({ height, width }))
    })
}
